<template>
  <div>
    <div>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="#"></a>
            <router-link :to="{name: 'account-money-claims', params: {id: accountId}}">
              {{$t('moneyClaim.detailsView.backLinkLabel')}}
            </router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page"> {{moneyClaimId}}</li>
        </ol>
      </nav>
    </div>
    <div>

    </div>
    <div>
      <card>
        <template slot="header">
          <h4 class="card-title d-inline">{{$t('moneyClaim.detailsView.title')}}</h4>
        </template>
        <template>
          <div v-loading="loading">
            <card v-if="moneyClaim">
              <money-claim-details :details="moneyClaim"/>
            </card>
            <finalise-money-claim
              v-if="moneyClaim && moneyClaim.status === 'started' && $auth.can({account_money_claim: 'update'}, 'permissions')"
              :account-id="accountId" :money-claim="moneyClaim"/>
          </div>
        </template>

      </card>
    </div>
  </div>
</template>

<script>
  import MoneyClaimDetails from 'src/components/MoneyClaim/MoneyClaimDetails'
  import FinaliseMoneyClaim from 'src/pages/Forms/FinaliseMoneyClaim'
  import {mapActions, mapState} from "vuex";

  export default {
    name: "AccountMoneyClaim",
    components: {
      MoneyClaimDetails,
      FinaliseMoneyClaim,
    },
    props: {
      accountId: {
        type: String,
        required: true
      },
      moneyClaimId: {
        type: String,
        required: true
      },
    },
    methods: {
      ...mapActions(['LoadAccountMoneyClaim']),
    },
    mounted() {
      // Loading user money-claims data
      this.LoadAccountMoneyClaim({accountID: this.accountId, moneyClaimID: this.moneyClaimId});
    },
    computed: {
      ...mapState({
        // darkTheme: state => state.app.darkMode,
        loading: state => state.account_money_claim.loading,
        moneyClaim: state => state.account_money_claim.data,
      }),
    },
  }
</script>

